module.exports = __webpack_public_path__ + "static/media/Telus_One_page-15.7df621b7.png";